export default __webpack_public_path__ + "static/media/shahad.aac20459.jpg";